import React from "react";
import "./rotationalContent.scss";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import DescriptionOrbit from "../DescriptionOrbit/DescriptionOrbit";
import ArrowButton from "../../atoms/arrowButton/arrowButton";
import palette from "../../../styles/palette.scss";
import Flag from "componets/molecules/flag/flag";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const RotationalContent = ({ className, textSize, data, isOnCalendar }) => {
  const [startingPoint, setStartingPoint] = React.useState(0); // Desde qué lugar empezamos a renderizar los datos
  const [grades, setGrades] = React.useState([]);
  let maxStartingPoint = 0;
  React.useEffect(() => {
    if (data && data.length == 1) maxStartingPoint = data.length - 1;
    if (data && data.length == 2) maxStartingPoint = data.length - 2;
    if (data && data.length >= 3) maxStartingPoint = data.length - 3;

    setGrades([180, 145, 0]);
    setStartingPoint(0);
  }, [data]);
  const handleClickDown = () => {
    // data.len = >=3,2,1,0
    //startingPoint limit = data.length-3, data.length-2, data.length-1
    //(startingPoint == data.length-3 && grades[0] == 360) || grades[startingPoint] == 360
    if (
      (data.length == 2 && grades[1] == 180) ||
      (data.length == 1 && grades[0] == 180) ||
      (data.length >= 3 && grades[2] == 180)
    ) {
      //Se espera que no haga nada
    } else if (startingPoint == 0 && grades[2] == 0) {
      let auxGrades = [...grades];
      auxGrades[2] = auxGrades[1] - 35;

      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade + 35;
      });
      setGrades(auxGrades);
    } else if (startingPoint == data.length - 3) {
      let auxGrades = [...grades];
      auxGrades[0] = 325;
      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade + 35;
      });
      setGrades(auxGrades);
    } else {
      setStartingPoint(startingPoint + 1);
    }
  };
  const handleClickUp = () => {
    if (startingPoint == 0 && grades[2] == 0) {
    } else if (startingPoint == data.length - 3 && grades[0] == 360) {
      let auxGrades = [...grades];
      auxGrades[0] = auxGrades[1] + 35;

      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade - 35;
      });
      setGrades(auxGrades);
    } else if (startingPoint == 0) {
      let auxGrades = [...grades];
      auxGrades[2] = 35;
      auxGrades.forEach((grade, index) => {
        auxGrades[index] = grade - 35;
      });
      setGrades(auxGrades);
    } else {
      setStartingPoint(startingPoint - 1);
    }
  };
  return (
    <>
      <div
        className={`${className} rotational-content__container font-size--${textSize}`}
      >
        <div className="rotational-content__buttons-container">
          <ArrowButton
            handleClick={
              data
                ? handleClickUp
                : () => {
                    alert("No hay datos por mostrar");
                  }
            }
            type={"up"}
          />
          <ArrowButton
            handleClick={
              data
                ? handleClickDown
                : () => {
                    alert("No hay más datos por mostrar");
                  }
            }
            type={"down"}
          />
        </div>

        <ol className={`rotation-content__list`}>
          {data ? (
            grades.map((grade, index) => (
              <>
                {startingPoint + index < data.length ? (
                  <>
                    {grade == 180 ? (
                      <>
                        <img
                          key={index}
                          className="rotational-content__image rotational-content__image-2"
                          src={data[startingPoint + index].imgURL}
                          alt="Panorámica de la entrada de la sede La Paz"
                        />
                        <div
                          key={index + data.length}
                          style={{
                            backgroundImage: `url(${
                              data[startingPoint + index].imgURL
                            })`,
                          }}
                          className="rotational-content__image rotational-content__image-1"
                          alt="Panorámica de la entrada de la sede La Paz"
                        >
                          {data[startingPoint + index].flags &&
                            data[startingPoint + index].flags.map(
                              (value, index) => (
                                <Flag
                                  key={index}
                                  data={{
                                    title: value.titulo,
                                    description: value.descripcion,
                                    href: value.link,
                                  }}
                                ></Flag>
                              )
                            )}
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <DescriptionOrbit
                      isOnCalendar={isOnCalendar}
                      percentageSize={grade == 180 ? "140%" : "100%"}
                      isOnFocus={grade == 180 ? true : false}
                      bgColor={palette.white}
                      color={"black"}
                      key={index + data.length * 2}
                      textSize={textSize}
                      rotation={grade}
                      data={data[startingPoint + index]}
                    />
                  </>
                ) : (
                  ""
                )}
              </>
            ))
          ) : (
            <DescriptionOrbit
              isOnFocus={true}
              bgColor={palette.white}
              color={"black"}
              textSize={textSize}
              rotation={180}
              data={{ title: "No se puedieron cargar los datos" }}
            />
          )}
        </ol>
      </div>
    </>
  );
};

export default RotationalContent;
